<ng-container *ngIf="config">
    <div class="modal-header d-flex justify-content-center">
        <h5 class="modal-title">
            <span class="font-weight-bold text_baseline">{{ config.title }}</span>
        </h5>
    </div>

    <div class="modal-body text-center px-3 py-3">
        <h5 class="mt-2 mb-1" *ngIf="!showProgress">{{ config.description }}</h5>

        <ng-container *ngIf="config.note && !showProgress">
            <p-messages severity="warn">
                <ng-template pTemplate>
                    <span class="d-flex">
                        <p class="font-weight-bold mx-2">NOTE:</p>
                        <p>{{ config.note }}</p>
                    </span>
                </ng-template>
            </p-messages>
        </ng-container>

        <div *ngIf="config.requireEmail && !showProgress || submissionError" class="form-group">
            <input type="email" class="form-control" placeholder="Enter email" [formControl]="emailControl" required>

            <div *ngIf="emailControl.dirty && emailControl.errors?.pattern || submissionError" class="text-danger">
                Please enter a valid email
            </div>
            <div *ngIf="emailControl.dirty && !emailControl.errors?.pattern && emailControl.errors?.emailMismatch" class="text-danger">Email does not match with your current logged-in email.</div>
        </div>

        <div *ngIf="config.showProgressBar && showProgress">
            <h5 class="mb-3 font-weight-semibold">{{ getUploadMessage() }}</h5>
            <p-progressBar [value]="progress" [showValue]="true" styleClass="custom-progress-bar"></p-progressBar>
            <p class="mt-3 text-muted small">
                Please do not close or refresh the page until the process is complete.
        </div>
    </div>

    <div class="modal-footer pb-2">
        <div class="d-flex justify-content-between w-100">
            <div>
                <div class="d-flex align-items-center" *ngIf="config.showCheckbox">
                    <p-checkbox [binary]="true" [formControl]="checkBoxControl"></p-checkbox>
                    <label class="mb-0 ml-1">{{ config.checkboxLabel }}</label>
                </div>
            </div>

            <div class="text-right m-1">
                <button (click)="close()" [disabled]="isLoading" class="btn btn-danger mr-2">{{ config.cancelLabel
                    }}</button>
                <button (click)="submit()" [disabled]="isDisabled()" class="btn btn-primary mr-2">
                    {{ config.confirmLabel }}
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm ml-1" role="status"
                        aria-hidden="true"></span>
                </button>
            </div>
        </div>


    </div>
</ng-container>